import {
  rem,
  withProp,
  switchProp,
  css,
  theme,
} from '@nobia/zeus-components/lib/styled'
import { transparentize } from '@nobia/zeus-components/lib/helpers/polished'

// TODO: move to main theme in zeus
const primaryColor = '#31261d'
const secondaryColor = '#1E44CB'
const mediumGreyColor = '#7A7A7A'
const whiteColor = '#FBF9F6'
const backgroundColor = '#F8F2EC'
const borderColor = '#C3B5A7'
const overlayBackdropColor = withProp(
  'theme.colors.black',
  transparentize(0.25)
)

const DesktopSizes = {
  sigdalXs: '14px',
  xxs: '16px',
  xs: '18px',
  s: '21px',
  sm: '26px',
  m: '16px',
  ml: '18px',
  xml: '20px',
  l: '32px',
  xl: '46px',
  mxl: '66px',
  xxl: '86px',
}

const MobileSizes = {
  sigdalXs: '13px',
  xxs: '16px',
  xs: '18px',
  s: '18px',
  sm: '21px',
  m: '16px',
  ml: '16px',
  xml: '18px',
  l: '26px',
  xl: '30px',
  mxl: '36px',
  xxl: '42px',
}

export default {
  typography: {
    headline: {
      color: primaryColor,
    },
    preamble: {
      color: primaryColor,
    },

    paragraph: {
      color: primaryColor,
    },
    title: {
      color: primaryColor,
      fontSize: rem(20),
      fontSizeDesktop: rem(20),
    },
  },
  pageTitle: {
    lineHeight: '71px',
    fontSize: '66px',
    hyphens: 'auto',
  },

  pageTitleMobile: {
    fontSize: '36px',
    lineHeight: '40px',
  },
  colors: {
    primary: primaryColor,
    secondary: secondaryColor,
    mediumGrey: mediumGreyColor,
    border: borderColor,
    price: primaryColor,
    compareHeader: primaryColor,
    backgroundPrimary: whiteColor,
  },

  breakpoints: {
    lg: 1280,
  },
  overlay: {
    lightbox: {
      backdrop: overlayBackdropColor,
    },
  },
  breadcrumbs: {
    default: {
      color: theme('colors.black'),
      colorHover: theme('colors.black'),
      colorMobile: theme('colors.black'),
    },
    hasBackground: {
      color: theme('colors.black'),
      colorHover: 'currentColor',
    },
  },
  button: {
    borderWidth: '1px',
    borderLeftPosition: '0',
    borderRightPosition: '0',
    padding: switchProp('size', {
      small: css`
        ${rem(10)} ${rem(40)};
      `,
      normal: css`
        ${rem(15)} ${rem(45)};
      `,
      large: css`
        ${rem(20)} ${rem(50)};
      `,
    }),
  },
  header: {
    title: {
      textTransform: 'none',
      letterSpacing: '0px',
    },
    mobile: {
      maxWidth: '100%',
    },
    layout: 'left',
    maxWidth: '837px',
  },
  menu: {
    item: {
      color: theme('colors.black'),
      colorHover: theme('colors.black'),
      opacityHover: '0.72',
    },
  },
  featureList: {
    title: {
      textTransform: 'none',
      letterSpacing: 'normal',
      fontWeight: '650 !important',
      fontSize: rem(14),
    },
    data: {
      fontSize: rem(14),
      fontWeight: '350',
    },
  },
  collapse: {
    color: theme('colors.black'),
    fontWeight: '650',
    backgroundColor: theme('colors.white'),
    border: {
      color: borderColor,
    },
    clearFilter: {
      fontWeight: '350',
      fontFamily: 'Lausanne',
    },
    productInfo: {
      borderColors: borderColor,
    },
  },
  sidePanel: {
    backgroundColor,
    buttons: {
      textTransform: 'none',
      fontWeight: '350',
    },
    clearButton: {
      backgroundColor: 'rgba(49, 38, 29, 0.2)',
    },
    viewButton: {
      backgroundColor: theme('colors.black'),
    },
  },
  app: {
    margin: '0 80px 0 80px',
  },
  wishListButton: {
    marginTop: '-10px',
    marginRight: '-20px',
    width: '40px!important',
    // eslint-disable-next-line
    backgroundColor: '#fff',
    paddingLeft: '7px!important',
    height: '38px',
    borderRadius: '50%',
    marginLeft: '5px',
    iconSize: '16px',
    prodPageIconSize: '21px',
    wishListBackground: {
      backgroundColor: 'transparent',
    },
  },
  productViewTable: {
    fontSize: DesktopSizes.sigdalXs,
  },
  subHeadline: {
    color: primaryColor,
    fontSize: `${DesktopSizes.l} !important`,
    lineHeight: '42px !important',
    mobile: {
      fontSize: `${MobileSizes.l} !important`,
      lineHeight: '30px !important',
    },
  },
  paging: {
    paddingTop: '0.6rem!important',
  },
  container: {
    medium: {
      width: 'auto',
    },
  },
  preamble: {
    color: primaryColor,
    fontSize: DesktopSizes.s,
    fontWeight: '350',
    fontSizeMobil: MobileSizes.s,
    lineHeightMobil: '28px',
    fontFamily: 'Lausanne',
  },

  price: {
    color: primaryColor,
  },
  pageMargin: {
    bottom: rem(70),
    marginRight: '80px',
    marginLeft: '80px',
  },
  pageMarginResponsiveMd: {
    paddingRight: '90px',
    paddingLeft: '90px',
  },
  pageMarginResponsiveSpecial: {
    paddingRight: '103px',
    paddingLeft: '103px',
  },
  pageMarginResponsiveSm: {
    paddingRight: '0px',
    paddingLeft: '0px',
  },
  background: {
    // eslint-disable-next-line
    backgroundColor: '#E4D4C4',
  },
  swipe: {
    button: {
      backgroundColor: 'transparent',
      border: '1px solid #31261D',
      marginTop: '6px',
      arrow: {
        width: '20px',
        height: '20px',
      },
    },
  },
  categoryCard: {
    fontFamily: 'Lausanne',
    backgroundColor: theme('colors.surface'),
    title: {
      fontSize: DesktopSizes.m,
      fontWeight: '650',
    },
  },
  styledHeadline: {
    fontSize: DesktopSizes.l,
    fontFamily: 'Reckless',
    fontWeight: '350',
    textTransform: 'lowercase',
    mobile: {
      fontSize: MobileSizes.l,
    },
  },
  productImage: {
    backgroundColor: '#fff',
  },
  productCard: {
    backgroundColor: '#fff',
    column: {
      mobile: {
        marginTop: '16px',
      },
    },
    fontSize: DesktopSizes.ml,
    fontWeight: '650',
    lineHeight: '22px',
    mobile: {
      fontFamily: MobileSizes.ml,
    },
    code: {
      fontSize: DesktopSizes.xxs,
      lineHeight: '24px',
      fontWeight: '350',
      order: 1,
      marginTop: 0,
      marginBottom: '8px',
      mobile: {
        fontSize: MobileSizes.xxs,
        marginTop: '8px',
        marginBottom: '16px',
      },
    },
    title: {
      fontSize: DesktopSizes.ml,
      lineHeight: '24px',
      fontWeight: '650',
    },
    price: {
      fontSize: DesktopSizes.sigdalXs,
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      mobile: {
        fontSize: MobileSizes.sigdalXs,
      },
    },
    bullets: {
      order: 3,
      marginTop: '24px',
      marginBottom: '12px',
    },
    preamble: {
      order: 4,
      marginTop: '12px',
      marginBottom: '12px',
    },
    infoBooking: {
      margin: '12px 0 8px 0',
    },
    fontFamily: 'Lausanne',
  },
  categories: {
    price: {
      fontSize: DesktopSizes.xxs,
    },
    row: {
      marginBottom: '24px',
    },
    filterPage: {
      gutter: '12px',
    },
  },
  readmore: {
    minHeight: '59px',
  },
  productCardBadge: {
    badge: {
      width: '62px',
    },
  },
  productGrid: {
    marginLeft: '16px',
    marginRight: '16px',
  },
  promotions: {
    cta: {
      fontFamily: 'Lausanne',
      fontWeight: '350',
      color: theme('colors.black'),
      content: {
        margin: '30px 0 40px 0',
      },
    },
    preamble: {
      fontFamily: 'Lausanne',
    },
    color: primaryColor,
    title: {
      color: primaryColor,
      fontFamily: 'Reckless',
      fontWeight: '350',
      fontSize: '32px',
      lineHeight: '38px',
      mobile: {
        fontSize: '26px',
        lineHeight: '30px',
      },
    },
  },
  dropdown: {
    color: theme('colors.black'),
    fontFamily: 'Lausanne',
    fontWeight: '350',
    lineHeight: '22px',
    borderColors: borderColor,
  },
}
